import React, { useState, useEffect, useRef, useCallback } from "react";
import { SubNavItem, ListItem, UL, Div } from "./styles";
import { useLocation, useHistory } from "react-router-dom";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import UnLoadScripts from "../popups/unLoadScript";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { globalFont } from "../utils/RepeatFunctions/Schedule";
import { useSelector } from "react-redux";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt/index.js";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import {
  decryptedPermission,
  getHighlightStyles,
  getItemHighlightStyles,
  getItemHighlightTemplate,
} from "../setting/HighlightConstants.js";
import { Button } from "react-bootstrap";
import { Modal } from "antd";
import { hi } from "date-fns/locale";

// Generic scroll-lock hook — same mechanism used for the Lab popup,
// reused for any nav popup that needs to freeze the sidebar scroll
// while it's open. It finds the nearest scrollable ancestor of
// `targetRef`, locks its overflow, and re-pins scrollTop on
// wheel/touch/scroll so the user can't scroll the nav away from the
// highlighted item while the guide popup is showing.
const useNavPopupScrollLock = (
  isActive,
  targetRef,
  getScrollableParent,
  delay = 450,
) => {
  const scrollParentRef = useRef(null);
  const scrollTopRef = useRef(0);

  useEffect(() => {
    if (!isActive) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = getScrollableParent(targetRef.current);
      if (!scrollParent) return;

      scrollParentRef.current = scrollParent;
      scrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (scrollParentRef.current) {
          scrollParentRef.current.scrollTop = scrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (scrollParentRef.current) {
          scrollParentRef.current.scrollTop = scrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });
      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });
      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;

        scrollParentRef.current = null;
      };
    }, delay);

    return () => {
      clearTimeout(timer);
      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [isActive, targetRef, getScrollableParent, delay]);

  return scrollParentRef;
};

const SettingsNav = ({
  scrollToTop,
  setOpenSubMenu,
  setIsOpen,
  setSettingsGuideHighlighted,
}) => {
  //------------------------------------------State and Variables Start------------------------------------------//
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");
  const [popupRefreshKey, setPopupRefreshKey] = useState(0);
  const [templateshowup1, settemplateshowup1] = useState(false);
  const [adminPopupPosition, setAdminPopupPosition] = useState({
    top: 0,
    left: 0,
  });
  const [openMenu, setOpenMenu] = useState(null);
  let history = useHistory();
  const location = useLocation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPatientOpen, setIsPatientOpen] = useState(
    location.state ? location?.state?.patientportalstarted : false,
  );
  const [isPayerOpen, setIsPayerOpen] = useState(
    location.state ? location?.state?.payerstateopen : false,
  );
  const highlightRef = useRef(null);
  const accountHighlightRef = useRef(null);
  const highlightPatientRef = useRef(null);
  const highlightPayerRef = useRef(null);

  const thirdPartyIntegrationRef = useRef(null);
  const [thirdPartyIntegrationPopup, setThirdPartyIntegrationPopup] =
    useState(false);

  const [isservicePopupOpen, setisservicePopupOpen] = useState(
    location.data ? location.data.serbillgetstart1 : false,
  );
  const [fromAccountSetup, setfromAccountSetup] = useState(
    location.state ? location.state?.fromAccountSetup : false,
  );
  const [fromAccountSetup1, setfromAccountSetup1] = useState(false);
  const [isfromAccountSetuperx, setisfromAccountSetuperx] = useState(
    location.state ? location.state.fromAccountSetuperx : false,
  );
  const Setuperxref = useRef(null);
  const [isfromNotificationSetup, setisfromNotificationSetup] = useState(
    location.state ? location.state.fromAccountSetupnotification : false,
  );
  const fromAccountSetupnotificationref = useRef(null);
  const servicesRef = useRef(null);
  const [isIntegrationOpen, setIsIntegrationOpen] = useState(
    location.state ? location?.state?.integrationstarted : false,
  );
  const integrationRef = useRef(null);

  const [isOnlineScheduleOpen, setIsOnlineScheduleOpen] = useState(
    location.state ? location?.state?.onlineschedulestarted : false,
  );
  const onlineScheduleRef = useRef(null);
  const onlineScheduleNavScrollParentRef = useRef(null);
  const onlineScheduleNavScrollTopRef = useRef(0);

  const [showOnlineScheduleTooltip, setShowOnlineScheduleTooltip] =
    useState(false);
  useEffect(() => {
    if (location.state?.integrationstarted) {
      setIsIntegrationOpen(true);
      setThirdPartyIntegrationPopup(false);
      setOpenMenu("integrations");
    }

    let expandTimer;
    let scrollTimer;

    if (location.state?.onlineschedulestarted) {
      setIsOnlineScheduleOpen(true);
      setOpenMenu("scheduling");

      expandTimer = setTimeout(() => {
        if (onlineScheduleRef.current) {
          onlineScheduleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        scrollTimer = setTimeout(() => {
          setShowOnlineScheduleTooltip(true);
        }, 600);
      }, 400);
    } else {
      setIsOnlineScheduleOpen(false);
      setShowOnlineScheduleTooltip(false);
    }

    return () => {
      clearTimeout(expandTimer);
      clearTimeout(scrollTimer);
    };
  }, [
    location.state?.integrationstarted,
    location.state?.onlineschedulestarted,
  ]);

  var accountType =
    localStorage.getItem("account_type") &&
    Decrypt_Value(localStorage.getItem("account_type"), "vozo");

  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [labPopup, setLabPopup] = useState(false);
  const labHighLightRef = useRef(null);
  const labNavScrollParentRef = useRef(null);
  const labNavScrollTopRef = useRef(0);
  // Moved up (was previously declared further down) because the
  // Payer Search scroll-lock hook below needs it during setup.
  const [showPayerTooltip, setShowPayerTooltip] = useState(false);

  const preventLabPopupNavScroll = useCallback(
    (e) => {
      const isOnlineFirstPopupOpen =
        isOnlineScheduleOpen && showOnlineScheduleTooltip;

      if (!labPopup && !isOnlineFirstPopupOpen) return;

      e.preventDefault();
      e.stopPropagation();

      if (labPopup && labNavScrollParentRef.current) {
        labNavScrollParentRef.current.scrollTop = labNavScrollTopRef.current;
      }

      if (isOnlineFirstPopupOpen && onlineScheduleNavScrollParentRef.current) {
        onlineScheduleNavScrollParentRef.current.scrollTop =
          onlineScheduleNavScrollTopRef.current;
      }
    },
    [labPopup, isOnlineScheduleOpen, showOnlineScheduleTooltip],
  );
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  var owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  var exploreusersidenav = useSelector(
    (state) => state.Schedule?.exploreusersidenav,
  );
  const [reposition, setReposition] = useState(false);

  const [usershowpop, setusershowpop] = useState(false);
  const [billingshowpop, setbillingshowpop] = useState(false);
  const [roles1, setroles1] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const rolesHighlightRef = useRef(null);
  const adminHighlightRef = useRef(null);
  const templatesHighlightRef = useRef(null);
  const UserHighlistRef = useRef(null);
  const billingServicesHighlightRef = useRef(null);
  const billingHighlightRef = useRef(null);

  const accountRoutes = [
    "accountsetup",
    "settingsmyprofile",
    "settingpracticeinfo",
    "Users",
    "Roles",
    "security",
    "myplan",
    "securitydocument",
    "timezonesettings",
  ];
  const billingRoutes = [
    "settingbilling",
    "settingservice",
    "payersearch",
    "lab",
  ];
  const schedulingRoutes = [
    "calendersettings",
    "appointmentreminder",
    "patientportal",
    "notificationsettings",
    "onlineschedule",
  ];
  const administrationRoutes = [
    "Inventory",
    "ERXsettings",
    "Templates",
    "Dataimport",
  ];

  const refMap = useRef({});
  const scrollGuideItemToCenter = useCallback(
    (targetRef, refreshDelay = 400) => {
      requestAnimationFrame(() => {
        if (!targetRef?.current) {
          scrollToTop?.();
          return;
        }

        targetRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });

        setTimeout(() => {
          setPopupRefreshKey((prev) => prev + 1);
        }, refreshDelay);
      });
    },
    [scrollToTop],
  );

  const getScrollableParent = useCallback((element) => {
    let parent = element?.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const canScroll =
        (overflowY === "auto" || overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight;

      if (canScroll) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return null;
  }, []);

  // --- Scroll locks for guided-tour popups (same mechanism as the Lab popup) ---

  // Enabling Patient Portal
  const patientPortalScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.setSchedulingPreferences && isPatientOpen,
    highlightPatientRef,
    getScrollableParent,
  );

  // Configure Your Billing
  // NOTE: uses billingServicesHighlightRef (the "Billing and Services"
  // header), not billingHighlightRef, because billingHighlightRef lives
  // inside the collapsible `{openMenu === "billing" && (...)}` block and
  // is unmounted (ref is null) whenever the popup opens before that
  // submenu has been expanded — e.g. via handleBillingOpenPopup / step "7".
  const billingScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.configureBillingServices && billingshowpop,
    billingServicesHighlightRef,
    getScrollableParent,
  );

  // Set up your Team Members
  const usersScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.manageAccountSettings && usershowpop,
    UserHighlistRef,
    getScrollableParent,
  );

  // Setting up your Account
  const accountSetupScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.manageAccountSettings && isPopupOpen,
    accountHighlightRef,
    getScrollableParent,
  );

  // Setting up User Permission (Roles)
  const rolesScrollParentRef = useNavPopupScrollLock(
    roles1,
    rolesHighlightRef,
    getScrollableParent,
  );

  // Add Insurance Payers
  const payerScrollParentRef = useNavPopupScrollLock(
    decryptedPermission.configureBillingServices &&
      showPayerTooltip &&
      parseInt(accountType) !== 1,
    highlightPayerRef,
    getScrollableParent,
  );

  useEffect(() => {
    const keysToScroll = [
      "Roles",
      "security",
      "securitydocument",
      "timezonesettings",
      "ERXsettings",
      "Dataimport",
    ];

    const currentKey = splitLocation[2];
    if (keysToScroll.includes(currentKey)) {
      // Wait for the DOM to update
      setTimeout(() => {
        if (refMap.current[currentKey]) {
          refMap.current[currentKey].scrollIntoView({
            behavior: "smooth",
            block: "center",
            // inline: "start"
          });
        }
      }, 200);
    }
  }, [splitLocation[2]]);

  useEffect(() => {
    const updatePopupPosition = () => {
      if (highlightRef.current && isPopupOpen) {
        const rect = highlightRef.current.getBoundingClientRect();
        setPopupPosition({
          top: rect.y + window.scrollY, // 10px below the highlighted section
          left: rect.left + window.scrollX,
        });
      }
    };

    return updatePopupPosition();
  }, [isPopupOpen]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "1.1") {
      setIsPopupOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    if (isservicePopupOpen) {
      scrollGuideItemToCenter(servicesRef, 400);
    }
  }, [isservicePopupOpen, scrollGuideItemToCenter]);

  useEffect(() => {
    let expandTimer;
    let scrollTimer;

    if (isPayerOpen) {
      setOpenMenu("billing");

      expandTimer = setTimeout(() => {
        if (highlightPayerRef.current) {
          highlightPayerRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        scrollTimer = setTimeout(() => {
          setShowPayerTooltip(true);
          window.dispatchEvent(new Event("resize"));
        }, 600);
      }, 400);
    } else {
      setShowPayerTooltip(false);
    }

    return () => {
      clearTimeout(expandTimer);
      clearTimeout(scrollTimer);
    };
  }, [isPayerOpen]);

  useEffect(() => {
    if (isfromAccountSetuperx) {
      scrollGuideItemToCenter(Setuperxref, 500);
    }
  }, [isfromAccountSetuperx, scrollGuideItemToCenter]);

  useEffect(() => {
    if (isfromNotificationSetup) {
      scrollGuideItemToCenter(fromAccountSetupnotificationref, 400);
    }
  }, [isfromNotificationSetup, scrollGuideItemToCenter]);

  useEffect(() => {
    if (decryptedPermission.manageAccountSettings && isPopupOpen) {
      // Only scroll if the popup is actually visible
      const timer = setTimeout(() => {
        if (accountHighlightRef.current) {
          accountHighlightRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setTimeout(() => {
            setPopupRefreshKey((prev) => prev + 1);
          }, 300);
        } else {
          scrollToTop?.();
        }
      }, 100); // Small delay to ensure popup is rendered

      return () => clearTimeout(timer);
    }
  }, [decryptedPermission.manageAccountSettings, scrollToTop, isPopupOpen]);

  useEffect(() => {
    setSettingsGuideHighlighted?.(
      Boolean(decryptedPermission.manageAccountSettings && isPopupOpen),
    );

    return () => {
      setSettingsGuideHighlighted?.(false);
    };
  }, [
    decryptedPermission.manageAccountSettings,
    isPopupOpen,
    setSettingsGuideHighlighted,
  ]);
  useEffect(() => {
    if (usershowpop && decryptedPermission.manageAccountSettings) {
      const timer = setTimeout(() => {
        if (UserHighlistRef.current) {
          UserHighlistRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });

          setTimeout(() => {
            setPopupRefreshKey((prev) => prev + 1);
          }, 300);
        } else {
          scrollToTop?.();
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [decryptedPermission.manageAccountSettings, usershowpop, scrollToTop]);
  const goTonewpayerOpen = () => {
    window.scrollTo(0, 0);
    history.replace({
      pathname: location.pathname,
      state: { newpayerstateopen: true, payerstateopen: false },
    });
  };

  useEffect(() => {
    // Turn off initial load after first render
    const timer = setTimeout(() => setIsInitialLoad(false), 500); // delay just to be safe
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let timeoutId;
    let animationFrameId;

    const handleScroll = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }

      animationFrameId = requestAnimationFrame(() => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
          setReposition((prev) => !prev);
        }, 100);
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, []);

  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const rolesNext2 = () => {
    setroles1(false);
    history.push("/settings/Roles", {
      showRolesPopup: true,
      activeTab: "3", // This will force tab 3 to be active
    });
  };

  const handleBillingOpenPopup = () => {
    setTimeout(() => {
      setbillingshowpop(true);
    }, 300);

    // Clear the state after handling it
    history.replace({
      ...location,
      state: {
        ...location.state,
        showBillingPopup: undefined,
      },
    });
  };

  const toggleItem = (title) => {
    setOpenMenu(openMenu === title ? null : title);
  };
  const currentItem = splitLocation[2];
  const dispatch = useDispatch();

  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  const getStartedNext = () => {
    history.replace({
      pathname: "/settings/settingsmyprofile",
      search: "?step=1.2",
    });
  };
  const getStartedNextaccountsetup = () => {
    history.push({
      pathname: "/settings/ERXsettings",
      state: { erxpopup: true },
    });
  };

  const forexploreusermenu7 = () => {
    setbillingshowpop(false);
    window.dispatchEvent(new Event("showNextBillingPopup"));
  };

  const forexploreusermenuback5 = () => {
    history.push({
      pathname: `/settings/Users`,
      state: { showStep5Popup: true },
    });
  };

  const forexploreusermenu = () => {
    setusershowpop(false);
    window.dispatchEvent(new Event("open2stepUserPopup"));
  };

  const handleUserOpenPopup = () => {
    setusershowpop(true);
    setOpenMenu("account");
    // Clear the state after handling it
    history.replace({
      ...location,
      state: {
        ...location.state,
        showUserPopup: undefined,
      },
    });
  };

  const forexploretemplatemenu2 = () => {
    settemplateshowup1(false);
    window.dispatchEvent(new Event("open2stepPopup"));
  };

  const backBillingOpenPopup = () => {
    setbillingshowpop(true);
  };
  const handleCloseMesg_1 = () => setisservicePopupOpen(false);
  const forexplorebillingservice = () => {
    setisservicePopupOpen(false);
    history.push({
      pathname: `/settings/settingservice`,
      data: { serbillgetstart: true },
      defaultTab: "7",
    });
  };
  const showNextStep = () => {
    setLabPopup(false);
    history.replace({
      pathname: location.pathname,
      search: "?step=9.2",
    });
  };
  const showNextThirdPartyIntegrationStep = () => {
    setThirdPartyIntegrationPopup(false);

    history.replace({
      pathname: "/settings/integrations",
      search: "?step=third-party.2",
    });
  };
  const fromAccountSetupfn = () => {
    setbillingshowpop(false);
    history.push({
      pathname: `/settings/settingbilling`,
      state: { billingPopup81: true },
    });
  };
  const getStartedNextnotificationsetup = () => {
    setisfromNotificationSetup(false);
    history.push({
      pathname: `/settings/notificationsettings`,
      state: {
        notificationpopup: true,
      },
    });
  };

  const shouldHighlight =
    decryptedPermission.configureBillingServices && parseInt(accountType) !== 1;

  const itemStyle = shouldHighlight
    ? {
      ...getHighlightStyles(isPayerOpen),
      padding: isPayerOpen ? "6px 10px" : "0px",
    }
    : undefined;
  // ------------------------------- Functions End--------------------------------------------------------- //
  // ------------------------------- UseEffect Start ------------------------------------------------------- //
  useEffect(() => {
    if (location.state?.showBillingPopup) {
      handleBillingOpenPopup();
    }

    window.addEventListener("open1stepBillingPopup", handleBillingOpenPopup);

    return () => {
      window.removeEventListener(
        "open1stepBillingPopup",
        handleBillingOpenPopup,
      );
    };
  }, [location.state, history, location]);

  useEffect(() => {
    if (roles1 && rolesHighlightRef.current) {
      rolesHighlightRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => {
        setReposition((prev) => !prev);
      }, 500);
    }
  }, [roles1]);

  useEffect(() => {
    if (location.state?.showUserPopup) {
      handleUserOpenPopup();
      // setOpenMenu("account");
    }

    window.addEventListener("open1stepUserPopup", handleUserOpenPopup);

    return () => {
      window.removeEventListener("open1stepUserPopup", handleUserOpenPopup);
    };
  }, [location.state, history, location]);

  useEffect(() => {
    if (templateshowup1) {
      requestAnimationFrame(() => {
        if (adminHighlightRef.current) {
          adminHighlightRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });

          // Slight delay to allow scroll animation to finish before updating popup
          setTimeout(() => {
            setPopupRefreshKey((prev) => prev + 1);
          }, 300); // match scroll duration
        }
      });
    }
  }, [templateshowup1]);
  useEffect(() => {
    const handleOpenPopup = () => {
      setTimeout(() => {
        settemplateshowup1(true);
      }, 150);
      setOpenMenu("administration");
      history.replace({
        ...location,
        state: {
          ...location.state,
          showTemplatePopup: undefined,
        },
      });
    };

    // if (location.state?.showTemplatePopup) {
    //   handleOpenPopup();
    // }

    // window.addEventListener("open1stepPopup", handleOpenPopup);

    // return () => {
    //   window.removeEventListener("open1stepPopup", handleOpenPopup);
    // };
  }, [location.state, history, location]);

  useEffect(() => {
    window.addEventListener("showBackUser6Popup", backBillingOpenPopup);

    return () => {
      window.removeEventListener("showBackUser6Popup", backBillingOpenPopup);
    };
  }, []);

  useEffect(() => {
    if (currentItem) {
      if (accountRoutes.includes(currentItem)) {
        setOpenMenu("account");
      } else if (currentItem === "integrations") {
        setOpenMenu("integrations");
      } else if (billingRoutes.includes(currentItem)) {
        setOpenMenu("billing");
      } else if (schedulingRoutes.includes(currentItem)) {
        setOpenMenu("scheduling");
      } else if (administrationRoutes.includes(currentItem)) {
        setOpenMenu("administration");
      }
    }
    UnLoadScripts();
    if (
      (splitLocation[1] === "settings" && splitLocation[2] === "nav") ||
      splitLocation[2] === "settingsmyprofile"
    ) {
      setOpenMenu("account");
    }
  }, []);
  useEffect(() => {
    if (exploreusersidenav === "account") {
      setOpenMenu("account");
    }
  }, [exploreusersidenav]);
  useEffect(() => {
    if (location?.state?.patientportalstarted !== undefined) {
      if (location?.state?.patientportalstarted === true) {
        window.scrollTo(0, 0);

        setIsPatientOpen(true);
      } else {
        setIsPatientOpen(false);
      }
    }
  }, [location?.state]);
  useEffect(() => {
    if (location?.state?.payerstateopen !== undefined) {
      if (location?.state?.payerstateopen === true) {
        setIsPayerOpen(true);
        setTimeout(() => {
          window.scrollTo({ top: 300, behavior: "smooth" });
        }, 100);
      } else {
        setIsPayerOpen(false);
      }
    }
  }, [location?.state]);
  useEffect(() => {
    if (location.state?.fromAccountSetupone) {
      setfromAccountSetup(false);
      setfromAccountSetup1(true);
    }
  }, [location.state]);
  useEffect(() => {
    if (location?.data && location.data?.serbillgetstart1) {
      setisservicePopupOpen(true);
    }
  }, [location?.data]);

  useEffect(() => {
    if (labPopup) {
      scrollGuideItemToCenter(labHighLightRef, 450);
    }
  }, [labPopup, scrollGuideItemToCenter]);

  useEffect(() => {
    if (!labPopup) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = getScrollableParent(labHighLightRef.current);

      if (!scrollParent) return;

      labNavScrollParentRef.current = scrollParent;
      labNavScrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (labNavScrollParentRef.current) {
          labNavScrollParentRef.current.scrollTop = labNavScrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (labNavScrollParentRef.current) {
          labNavScrollParentRef.current.scrollTop = labNavScrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;

        labNavScrollParentRef.current = null;
      };
    }, 500);

    return () => {
      clearTimeout(timer);

      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [labPopup, getScrollableParent]);

  useEffect(() => {
    const isOnlineFirstPopupOpen =
      isOnlineScheduleOpen && showOnlineScheduleTooltip;

    if (!isOnlineFirstPopupOpen) return;

    let cleanupScrollLock = null;

    const timer = setTimeout(() => {
      const scrollParent = getScrollableParent(onlineScheduleRef.current);

      if (!scrollParent) return;

      onlineScheduleNavScrollParentRef.current = scrollParent;
      onlineScheduleNavScrollTopRef.current = scrollParent.scrollTop;

      const previousOverflowY = scrollParent.style.overflowY;
      const previousOverscrollBehavior = scrollParent.style.overscrollBehavior;

      scrollParent.style.overflowY = "hidden";
      scrollParent.style.overscrollBehavior = "contain";

      const lockScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (onlineScheduleNavScrollParentRef.current) {
          onlineScheduleNavScrollParentRef.current.scrollTop =
            onlineScheduleNavScrollTopRef.current;
        }
      };

      const keepScrollFixed = () => {
        if (onlineScheduleNavScrollParentRef.current) {
          onlineScheduleNavScrollParentRef.current.scrollTop =
            onlineScheduleNavScrollTopRef.current;
        }
      };

      scrollParent.addEventListener("wheel", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("touchmove", lockScroll, {
        passive: false,
        capture: true,
      });

      scrollParent.addEventListener("scroll", keepScrollFixed, true);

      cleanupScrollLock = () => {
        scrollParent.removeEventListener("wheel", lockScroll, true);
        scrollParent.removeEventListener("touchmove", lockScroll, true);
        scrollParent.removeEventListener("scroll", keepScrollFixed, true);

        scrollParent.style.overflowY = previousOverflowY;
        scrollParent.style.overscrollBehavior = previousOverscrollBehavior;

        onlineScheduleNavScrollParentRef.current = null;
      };
    }, 500);

    return () => {
      clearTimeout(timer);

      if (cleanupScrollLock) {
        cleanupScrollLock();
      }
    };
  }, [isOnlineScheduleOpen, showOnlineScheduleTooltip, getScrollableParent]);

  useEffect(() => {
    if (
      (thirdPartyIntegrationPopup || isIntegrationOpen) &&
      thirdPartyIntegrationRef.current
    ) {
      thirdPartyIntegrationRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setTimeout(() => {
        setPopupRefreshKey((prev) => prev + 1);
      }, 300);
    }
  }, [thirdPartyIntegrationPopup, isIntegrationOpen]);

  useEffect(() => {
    const handleTrigger = () => {
      setroles1(true);
    };
    const handleClose = () => {
      setroles1(false);
    };

    window.addEventListener("triggerRolesPopup", handleTrigger);
    window.addEventListener("closeRolesPopup", handleClose);

    return () => {
      window.removeEventListener("triggerRolesPopup", handleTrigger);
      window.removeEventListener("closeRolesPopup", handleClose);
    };
  }, []);

  useEffect(() => {
    // Check if navigation state contains showPopup flag
    if (location.state?.Rolesstarted) {
      setroles1(true);

      // Clear the state after showing popup
      history.replace(location.pathname, {});
    }
  }, [location.state]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    setOpenSubMenu("settings");

    if (step === "1") {
      setisservicePopupOpen(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "9") {
      setOpenMenu("billing");

      setTimeout(() => {
        scrollGuideItemToCenter(labHighLightRef, 450);
        setLabPopup(true);
      }, 150);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "9.1") {
      setOpenMenu("integrations");
      setIsIntegrationOpen(false);
      setThirdPartyIntegrationPopup(false);

      setTimeout(() => {
        setThirdPartyIntegrationPopup(true);
      }, 300);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "5") {
      setisfromNotificationSetup(true);

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "6") {
      const erxElement = refMap.current["ERXsettings"];

      if (erxElement && typeof erxElement.scrollIntoView === "function") {
        erxElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        setTimeout(() => {
          setisfromAccountSetuperx(true);
        }, 500);
      }

      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "7") {
      setbillingshowpop(true);
      setfromAccountSetup1(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    } else if (step === "2.1") {
      setusershowpop(true);
      query.delete("step");
      setfromAccountSetup(true);
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    const accsetup =
      // templateshowup1 ||
      billingshowpop ||
      usershowpop ||
      labPopup ||
      thirdPartyIntegrationPopup ||
      isfromAccountSetuperx ||
      isfromNotificationSetup ||
      isPayerOpen ||
      isPopupOpen ||
      isservicePopupOpen ||
      roles1 ||
      isIntegrationOpen;

    if (accsetup) {
      document.body.style.overflow = "hidden"; // disable scroll
    } else {
      document.body.style.overflow = ""; // enable scroll
    }

    return () => {
      document.body.style.overflow = ""; // cleanup on unmount
    };
  }, [
    // templateshowup1,
    billingshowpop,
    usershowpop,
    roles1,
    labPopup,
    thirdPartyIntegrationPopup,
    isfromAccountSetuperx,
    isfromNotificationSetup,
    isPayerOpen,
    isPopupOpen,
    isservicePopupOpen,
    isIntegrationOpen,
  ]);

  // ------------------------------- UseEffect End ------------------------------------------------------- //

  return (
    <>
      {
        // parseInt(accountType) !== 0 &&
        // (templateshowup1 &&
        //   decryptedPermission.manageAdministrationSettings) ||
        ((billingshowpop &&
          // && parseInt(accountType) !== 1
          decryptedPermission.configureBillingServices) ||
          (roles1 && decryptedPermission.manageAccountSettings)) && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 1000,
            }}
            onClick={() => {
              settemplateshowup1(false);
              setbillingshowpop(false);
            }}
          />
        )
      }
      {decryptedPermission.manageAccountSettings && usershowpop && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
          onClick={() => setIsPopupOpen(false)}
        />
      )}

      {thirdPartyIntegrationPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
          }}
          onClick={() => setThirdPartyIntegrationPopup(false)}
        />
      )}

      {decryptedPermission.configureBillingServices &&
        parseInt(accountType) !== 1 &&
        (isservicePopupOpen ||
          (decryptedPermission.setSchedulingPreferences &&
            isfromNotificationSetup &&
            parseInt(accountType) > 1) ||
          (isfromAccountSetuperx &&
            decryptedPermission.manageAdministrationSettings)) && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 1000,
            }}
            onClick={() => setisservicePopupOpen(false)}
          />
        )}

      {decryptedPermission.configureBillingServices &&
        parseInt(accountType) !== 1 &&
        isIntegrationOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 1000,
            }}
            onClick={() => setIsIntegrationOpen(false)}
          />
        )}

      <Div
        width="100%"
        paddingLeft="0.86em"
        margin="24px 0 0 16px"
        onWheelCapture={preventLabPopupNavScroll}
        onTouchMoveCapture={preventLabPopupNavScroll}
        style={
          labPopup || (isOnlineScheduleOpen && showOnlineScheduleTooltip)
            ? {
              overscrollBehavior: "contain",
            }
            : undefined
        }
      >
        <Div
          ref={highlightRef}
          className="main-position-highlight"
          style={
            decryptedPermission.manageAccountSettings
              ? isPopupOpen
                ? {
                  ...getHighlightStyles(true),
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  margin: "0 -20px",
                  padding: "0 20px",
                }
                : {}
              : {}
          }
        >
          <Popup
            key={popupRefreshKey}
            offset={[50, -10]}
            content={
              <GetStartedPopup
                title="Setting up your Account"
                description={
                  <div>
                    Go to Settings {">"} Account Settings menu fill out the set
                    up details to up and run your application.
                    <div className="mt-5px">By doing so you can:</div>
                  </div>
                }
                bullets={[
                  "Manage your personal information and credentials",
                  "Set or update details related to your clinic or practice facility.",
                ]}
                currentStep={1}
                totalSteps={7}
                onNext={() => {
                  setIsPopupOpen(false);
                  getStartedNext();
                  location.data = null;
                }} // or handle steps
                onClose={() => setIsPopupOpen(false)}
                width="320px"
              />
            }
            open={decryptedPermission.manageAccountSettings && isPopupOpen}
            className="m-t-10"
            context={accountHighlightRef.current}
            trigger={
              <Div
                cursor="pointer"
                display="flex"
                fontWeight="600"
                fontSize="14px"
                color={
                  openMenu === "account" ? "#2E2E2E" : "rgba(46, 46, 46, 0.50)"
                }
                fontFamily={globalFont}
                svgFontSize="16px"
                svgMarginLeft="8px"
                svgMarginTop="4px"
                onClick={() => {
                  toggleItem("account");
                }}
              >
                <Div>Account settings</Div>
                {openMenu === "account" ? <FiChevronUp /> : <FiChevronDown />}
              </Div>
            }
            position="right center"
            modal={{
              style: { height: "100%", width: "100%" },
            }}
          />
        </Div>
        {decryptedPermission.setSchedulingPreferences && isPatientOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 50,
            }}
            onClick={() => {
              setIsPatientOpen(false);
              setisservicePopupOpen(false);
              history.push({
                pathname: location.pathname,
                state: {
                  patientportalstarted: false,
                },
              });
            }}
          />
        )}
        {openMenu === "account" && (
          <UL
            textAlign="left"
            width="100%"
            listStyleType="none"
            padding="0"
            margin="0"
          >
            <Div
              ref={accountHighlightRef}
              style={
                decryptedPermission.manageAccountSettings
                  ? isPopupOpen
                    ? {
                      ...getHighlightStyles(true),
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: 0,
                      display: "flex",
                      flexDirection: "column",
                      margin: "0 -20px",
                      padding: "0 20px",
                    }
                    : {}
                  : {}
              }
            >
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem
                  to="/settings/accountsetup"
                  id="setting_nav_profile"
                  exact
                  className={
                    splitLocation[2] === "accountsetup" ? "active" : ""
                  }
                >
                  Account Setup
                </SubNavItem>
              </ListItem>
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
                style={{ ...getItemHighlightStyles(isPopupOpen) }}
              >
                <SubNavItem
                  to="/settings/settingsmyprofile"
                  id="setting_nav_profile"
                  exact
                  className={
                    splitLocation[2] === "settingsmyprofile" ? "active" : ""
                  }
                >
                  My Profile
                </SubNavItem>
              </ListItem>
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
                style={getItemHighlightStyles(isPopupOpen)}
              >
                <SubNavItem
                  to="/settings/settingpracticeinfo"
                  exact
                  id="setting_nav_facility"
                >
                  Facility Information
                </SubNavItem>
              </ListItem>
            </Div>
            <Div
              ref={UserHighlistRef}
              style={
                decryptedPermission.manageAccountSettings
                  ? {
                    ...getItemHighlightTemplate(usershowpop),
                    margin: "0 -20px",
                    padding: "4px 20px",
                  }
                  : {}
              }
            >
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                <Popup
                  key={popupRefreshKey}
                  offset={[-70, 20]}
                  content={
                    <GetStartedPopup
                      title="Set up your Team Members"
                      description={
                        <div>
                          {fromAccountSetup ? (
                            <>
                              Go to Settings {">"} User menu to add providers
                              and staff that are required for your facility
                            </>
                          ) : (
                            <>
                              Go to Settings {">"} User & Billing menu to add
                              providers and staff that are required for your
                              facility & configure Stripe key for payments.
                            </>
                          )}
                          <br />
                          <div style={{ marginTop: "5px" }}>
                            By doing so you can:
                          </div>
                        </div>
                      }
                      bullets={
                        fromAccountSetup
                          ? [
                            "Create & Manage your provider and staff personnel.",
                            "Assign roles & permissions based on the users.",
                          ]
                          : [
                            "Create & Manage your provider and staff personnel.",
                            "Assign roles & permissions based on the users.",
                            "Set up your Stripe credentials key and clearinghouse configuration.",
                          ]
                      }
                      currentStep={1}
                      totalSteps={fromAccountSetup ? 5 : 9}
                      onNext={() => {
                        if (fromAccountSetup) {
                          setfromAccountSetup(false);
                          setusershowpop(false);
                          history.replace({
                            pathname: location.pathname,
                            search: "?step=2.2",
                          });
                        } else {
                          forexploreusermenu();
                        }
                      }}
                      width="390px"
                      onClose={() => {
                        if (fromAccountSetup) {
                          setusershowpop(false);
                          setfromAccountSetup(false);
                        } else {
                          setusershowpop(false);
                        }
                      }}
                    />
                  }
                  open={
                    decryptedPermission.manageAccountSettings && usershowpop
                  }
                  className="useraspop m-t-10 "
                  onClose={() => {
                    if (!fromAccountSetup) {
                      setusershowpop(false);
                    }
                  }}
                  trigger={
                    <SubNavItem
                      to="/settings/Users"
                      exact
                      id="setting_nav_users"
                    >
                      Users
                    </SubNavItem>
                  }
                  position="right center"
                />
              </ListItem>
            </Div>
            <Div
              ref={rolesHighlightRef}
              style={
                decryptedPermission.manageAccountSettings
                  ? {
                    ...getItemHighlightTemplate(roles1),
                    margin: "0 -20px",
                    padding: "4px 20px",
                  }
                  : {}
              }
            >
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                {decryptedPermission.manageAccountSettings ? (
                  <Popup
                    key={reposition}
                    offset={[-20, 10]}
                    content={
                      <GetStartedPopup
                        title="Setting up User Permission"
                        description={
                          <div>
                            Go to Settings {">"} Account Settings {">"} Roles &
                            Permission menu to add new roles and set permission
                            to them.
                          </div>
                        }
                        currentStep={1}
                        totalSteps={5}
                        onNext={() => rolesNext2()}
                        width="390px"
                        onClose={() => setroles1(false)}
                      />
                    }
                    open={roles1}
                    className="centerarrowpopup m-t-10 "
                    trigger={
                      <SubNavItem
                        to="/settings/Roles"
                        exact
                        ref={(el) => (refMap.current["Roles"] = el)}
                      >
                        Roles and Permissions
                      </SubNavItem>
                    }
                    position="right center"
                  />
                ) : (
                  <SubNavItem
                    to="/settings/Roles"
                    exact
                    ref={(el) => (refMap.current["Roles"] = el)}
                  >
                    Roles and Permissions
                  </SubNavItem>
                )}
              </ListItem>
            </Div>
            <ListItem marginTop="16px" onClick={handleInputChange("iconopen")}>
              <SubNavItem
                to="/settings/security"
                exact
                ref={(el) => (refMap.current["security"] = el)}
              >
                Security
              </SubNavItem>
            </ListItem>
            {(owner_id === null || owner_id === " ") && (
              <ListItem
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                <SubNavItem to="/settings/myplan" exact id="setting_nav_myplan">
                  My plan
                </SubNavItem>
              </ListItem>
            )}
            <ListItem marginTop="16px" onClick={handleInputChange("iconopen")}>
              <SubNavItem
                to="/settings/securitydocument"
                exact
                id="setting_nav_document"
                ref={(el) => (refMap.current["securitydocument"] = el)}
              >
                Documents
              </SubNavItem>
            </ListItem>
            <ListItem marginTop="16px" onClick={handleInputChange("iconopen")}>
              <SubNavItem
                to="/settings/timezonesettings"
                exact
                id="setting_nav_timezone"
                ref={(el) => (refMap.current["timezonesettings"] = el)}
              >
                Time Zone Settings
              </SubNavItem>
            </ListItem>
          </UL>
        )}

        <Div
          ref={thirdPartyIntegrationRef}
          style={
            thirdPartyIntegrationPopup || isIntegrationOpen
              ? {
                ...getHighlightStyles(true),
                marginTop: "24px",
                marginLeft: "-20px",
                marginRight: "-20px",
                padding: "8px 20px",
              }
              : { marginTop: "24px" }
          }
        >
          <Popup
            key={popupRefreshKey}
            offset={isIntegrationOpen ? [30, 10] : [40, 15]}
            content={
              <GetStartedPopup
                title="Third Party Integrations"
                description={
                  isIntegrationOpen ? (
                    <div style={{ marginTop: "5px" }}>
                      Go to Settings {">"} Integration menu to link and
                      configure with all the 3rd party integration platforms.
                    </div>
                  ) : (
                    "Go to Settings > Integration menu to link and configure with all the 3rd party integration platforms."
                  )
                }
                currentStep={1}
                totalSteps={13}
                onNext={() => {
                  if (thirdPartyIntegrationPopup) {
                    showNextThirdPartyIntegrationStep();
                    return;
                  }

                  setIsIntegrationOpen(false);

                  history.push({
                    pathname: "/settings/integrations",
                    state: { integrationstarted2: true },
                  });

                  toggleItem("integrations");
                }}
                onClose={() => {
                  setThirdPartyIntegrationPopup(false);
                  setIsIntegrationOpen(false);

                  if (isIntegrationOpen) {
                    history.replace({
                      pathname: location.pathname,
                      state: { integrationstarted: false },
                    });
                  }
                }}
                width={isIntegrationOpen ? "340px" : "320px"}
              />
            }
            open={
              thirdPartyIntegrationPopup ||
              (decryptedPermission.configureBillingServices &&
                isIntegrationOpen &&
                parseInt(accountType) !== 1)
            }
            className="m-t-10"
            trigger={
              <Div
                cursor="pointer"
                display="flex"
                fontWeight="600"
                fontSize="14px"
                color={
                  openMenu === "integrations"
                    ? "#2E2E2E"
                    : "rgba(46, 46, 46, 0.50)"
                }
                fontFamily={globalFont}
                svgFontSize="16px"
                svgMarginLeft="8px"
                svgMarginTop="4px"
                onClick={() => {
                  history.push("/settings/integrations");
                  toggleItem("integrations");
                }}
                id="setting_integrations"
              >
                <Div>Integrations</Div>
                {openMenu === "integrations" ? (
                  <FiChevronUp />
                ) : (
                  <FiChevronDown />
                )}
              </Div>
            }
            position="right center"
            on={[]}
          />
        </Div>
        <Div
          ref={billingServicesHighlightRef}
          className="admin-position-highlight"
          style={
            decryptedPermission.configureBillingServices
              ? // && parseInt(accountType) !== 1
              getHighlightStyles(billingshowpop)
              : {}
          }
        >
          <Div
            cursor="pointer"
            display="flex"
            fontWeight="600"
            fontSize="14px"
            color={
              openMenu === "billing" ? "#2E2E2E" : "rgba(46, 46, 46, 0.50)"
            }
            fontFamily={globalFont}
            svgFontSize="16px"
            svgMarginLeft="8px"
            svgMarginTop="4px"
            marginTop="24px"
            onClick={() => toggleItem("billing")}
          >
            <Div id="setting_bill_service">Billing and Services</Div>

            {openMenu === "billing" ? <FiChevronUp /> : <FiChevronDown />}
          </Div>
        </Div>
        {openMenu === "billing" && (
          <UL
            textAlign="left"
            width="100%"
            listStyleType="none"
            padding="0"
            margin="0"
          >
            <Div
              style={
                decryptedPermission.configureBillingServices
                  ? // && parseInt(accountType) !== 1
                  getItemHighlightTemplate(billingshowpop)
                  : {}
              }
            >
              <ListItem
                            ref={billingHighlightRef}

                marginTop="16px"
                onClick={handleInputChange("iconopen")}
                style={
                  decryptedPermission.configureBillingServices
                    ? // && parseInt(accountType) !== 1
                    getItemHighlightTemplate(billingshowpop)
                    : {}
                }
              >
                <Popup
                  offset={[-30, 140]}
                  content={
                    <GetStartedPopup
                      title="Configure Your Billing"
                      description={
                        <div>
                          Go to Settings {">"} Billing menu to set up your
                          Billing details for payment processing.
                          <div style={{ marginTop: "5px" }}>
                            By doing so you can:
                          </div>
                        </div>
                      }
                      bullets={
                        fromAccountSetup
                          ? [
                            "Set up online payment and billing system using Stripe integration",
                          ]
                          : fromAccountSetup1
                            ? [
                              "Add or manage connections with insurance payers through clearinghouses",
                            ]
                            : [
                              "Set up online payment and billing system using Stripe integration",
                              "Add or manage connections with insurance payers through clearinghouses",
                            ]
                      }
                      currentStep={
                        fromAccountSetup || fromAccountSetup1 ? 1 : 6
                      }
                      totalSteps={
                        fromAccountSetup ? 2 : fromAccountSetup1 ? 3 : 9
                      }
                      onNext={
                        !fromAccountSetup1
                          ? () => forexploreusermenu7()
                          : () => fromAccountSetupfn()
                      }
                      width="340px"
                      onBack={
                        fromAccountSetup || fromAccountSetup1
                          ? null
                          : () => forexploreusermenuback5()
                      }
                      onClose={() => setbillingshowpop(false)}
                    />
                  }
                  open={
                    decryptedPermission.configureBillingServices &&
                    billingshowpop
                    // && parseInt(accountType) == 1
                  }
                  className=" billingaspop m-t-10"
                  onClose={() => setbillingshowpop(false)}
                  // trigger={
                  //   <SubNavItem to="/settings/settingbilling" exact>
                  //     Billing
                  //   </SubNavItem>
                  // }
                  position="right center"
                // context={billingServicesHighlightRef.current}
                />
              </ListItem>
            </Div>
            <ListItem
              ref={servicesRef}
              style={
                decryptedPermission.configureBillingServices &&
                  parseInt(accountType) !== 1
                  ? {
                    ...getHighlightStyles(isservicePopupOpen),
                    padding: isservicePopupOpen ? "4px 10px" : "0px",
                  }
                  : {}
              }
              marginTop="16px"
              onClick={handleInputChange("iconopen")}
            >
              <Popup
                key={popupRefreshKey}
                offset={[87, 20]}
                content={
                  <GetStartedPopup
                    title="Configure Your Billing"
                    description="Go to Settings > Services menu to set up your Services codes for using procedures during appointments."
                    currentStep={1}
                    totalSteps={11}
                    onNext={() => forexplorebillingservice()}
                    onClose={() => handleCloseMesg_1()}
                    bullethead="By doing so you can:"
                    bullets={[
                      "Diagnose patients with ICD10 codes.",
                      "Add Procedures codes for the services provided during appointment.",
                      "Receive payment for the set service codes.",
                    ]}
                    width="330px"
                  />
                }
                open={
                  parseInt(accountType) !== 1 &&
                  decryptedPermission.configureBillingServices &&
                  isservicePopupOpen
                }
                trigger={
                  <SubNavItem
                    to="/settings/settingservice"
                    exact
                    id="setting_nav_services"
                  >
                    Services
                  </SubNavItem>
                }
                position="right center"
              />
            </ListItem>
            <ListItem
              marginTop="16px"
              onClick={handleInputChange("iconopen")}
              ref={highlightPayerRef}
              style={itemStyle}
            >
              <Popup
                key={popupRefreshKey}
                offset={[40, 25]}
                content={
                  <GetStartedPopup
                    title="Add Insurance Payers"
                    description={
                      <div style={{ marginTop: "5px" }}>
                        Go to Settings {">"} Billing {">"} Payer Search menu to
                        add insurance payers that are associated with the
                        patients.
                      </div>
                    }
                    currentStep={1}
                    totalSteps={3}
                    onNext={() => {
                      setIsPayerOpen(false);
                      setShowPayerTooltip(false);
                      goTonewpayerOpen();
                    }}
                    topClose="0px"
                    rightClose="3px"
                    width="340px"
                    onClose={() => {
                      setIsPayerOpen(false);
                      setShowPayerTooltip(false);
                      history.replace({
                        pathname: location.pathname,
                        state: { payerstateopen: false },
                      });
                    }}
                  />
                }
                open={
                  decryptedPermission.configureBillingServices &&
                  showPayerTooltip &&
                  parseInt(accountType) !== 1
                }
                disabled={!showPayerTooltip}
                trigger={
                  <SubNavItem
                    to="/settings/payersearch"
                    exact
                    id="setting_nav_payer"
                  >
                    Payer Search
                  </SubNavItem>
                }
                position="right center"
              />
            </ListItem>
            <ListItem
              marginTop="16px"
              onClick={handleInputChange("iconopen")}
              style={
                decryptedPermission.configureBillingServices
                  ? {
                    position: "relative",
                    backgroundColor: labPopup ? "#f0f7ff" : "transparent",
                    zIndex: 9999,
                    padding: labPopup ? "10px" : "0px",
                  }
                  : {}
              }
              ref={labHighLightRef}
            >
              <Popup
                key={popupRefreshKey}
                offset={isInitialLoad ? [0, 30] : [0, 15]}
                content={
                  <GetStartedPopup
                    title="Configuring Lab for Orders"
                    description="Go to Settings > Billing & Services > Lab menu to configure labs in order to order variety of lab orders to different labs."
                    currentStep={1}
                    totalSteps={9}
                    onNext={showNextStep}
                    width="390px"
                    onClose={() => setLabPopup(false)}
                  />
                }
                open={decryptedPermission.configureBillingServices && labPopup}
                className="centerarrowpopup m-t-10"
                context={labHighLightRef.current}
                trigger={
                  <SubNavItem to="/settings/lab" exact id="setting_nav_lab">
                    Lab
                  </SubNavItem>
                }
                position="right center"
              />
            </ListItem>
          </UL>
        )}
        {decryptedPermission.configureBillingServices &&
          isPayerOpen &&
          parseInt(accountType) !== 1 && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                zIndex: 50,
              }}
              onClick={() => {
                setIsPayerOpen(false);
                setisservicePopupOpen(false);
                history.push({
                  pathname: location.pathname,
                  state: {
                    payerstateopen: false,
                  },
                });
              }}
            />
          )}
        <Div ref={highlightPatientRef}>
          <Div
            cursor="pointer"
            display="flex"
            fontWeight="600"
            fontSize="14px"
            color={
              openMenu === "scheduling" ? "#2E2E2E" : "rgba(46, 46, 46, 0.50)"
            }
            fontFamily={globalFont}
            svgFontSize="16px"
            svgMarginLeft="8px"
            svgMarginTop="4px"
            marginTop="24px"
            style={
              decryptedPermission.setSchedulingPreferences
                ? isPatientOpen
                  ? {
                    ...getHighlightStyles(true),
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    margin: "0 -20px",
                    padding: "0 20px",
                  }
                  : {}
                : {}
            }
            onClick={() => toggleItem("scheduling")}
          >
            <Div id="setting_nav_scheduling">Scheduling</Div>
            {openMenu === "scheduling" ? <FiChevronUp /> : <FiChevronDown />}
          </Div>
          {openMenu === "scheduling" && (
            <UL
              textAlign="left"
              width="100%"
              listStyleType="none"
              padding="0"
              margin="0"
            >
              {" "}
              <Div
                style={
                  decryptedPermission.setSchedulingPreferences
                    ? isPatientOpen
                      ? {
                        ...getHighlightStyles(true),
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        display: "flex",
                        flexDirection: "column",
                        margin: "0 -20px",
                        padding: "0 20px",
                      }
                      : {}
                    : {}
                }
              >
                <ListItem
                  marginTop="16px"
                  onClick={handleInputChange("iconopen")}
                >
                  <SubNavItem
                    to="/settings/calendersettings"
                    exact
                    id="setting_nav_calendersetting"
                  >
                    Calendar Settings
                  </SubNavItem>
                </ListItem>
                <ListItem
                  marginTop="16px"
                  onClick={handleInputChange("iconopen")}
                >
                  <SubNavItem
                    to="/settings/appointmentreminder"
                    exact
                    id="setting_nav_reminder"
                  >
                    Appointment Reminders
                  </SubNavItem>
                </ListItem>
                <ListItem
                  marginTop="16px"
                  onClick={handleInputChange("iconopen")}
                >
                  <SubNavItem to="/settings/patientportal/all" exact>
                    Patient Portal Settings
                  </SubNavItem>
                </ListItem>
              </Div>
              {/* <ListItem
                ref={fromAccountSetupnotificationref}
                style={
                  decryptedPermission.setSchedulingPreferences &&
                    parseInt(accountType) > 1
                    ? {
                      ...getHighlightStyles(isfromNotificationSetup),
                    }
                    : {}
                }
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                {" "}
                <Popup
                  key={popupRefreshKey}
                  offset={[40, 40]}
                  content={
                    <GetStartedPopup
                      title="Setting up Notification Settings"
                      description={
                        <div>
                          Go to Settings {">"} Scheduling {">"} Notification
                          Settings menu to set up your credentials to send
                          notifications.
                        </div>
                      }
                      currentStep={1}
                      totalSteps={2}
                      onNext={() => {
                        setisfromNotificationSetup(false);
                        getStartedNextnotificationsetup();
                        location.data = null;
                      }} // or handle steps
                      onClose={() => setisfromNotificationSetup(false)}
                      width="320px"
                    />
                  }
                  open={
                    parseInt(accountType) > 1 &&
                    decryptedPermission.setSchedulingPreferences &&
                    isfromNotificationSetup
                  }
                  disabled={!isfromNotificationSetup}
                  className="m-t-10"
                  trigger={
                    <SubNavItem to="/settings/notificationsettings" exact>
                      Reminder Settings
                    </SubNavItem>
                  }
                  position="left center"
                />
              </ListItem> */}
              <ListItem
                ref={onlineScheduleRef}
                style={
                  isOnlineScheduleOpen
                    ? {
                      ...getHighlightStyles(isOnlineScheduleOpen),
                      padding: "6px 10px",
                    }
                    : {}
                }
                marginTop="16px"
                onClick={handleInputChange("iconopen")}
              >
                {isOnlineScheduleOpen ? (
                  <Popup
                    offset={[60, 20]}
                    content={
                      <GetStartedPopup
                        title="Enable Online Scheduling Widget"
                        bullets={[
                          "Go to Settings > Scheduling > Online Schedule Settings menu to enable & configure the external online scheduling widget for patient.",
                        ]}
                        currentStep={1}
                        totalSteps={8}
                        width="300px"
                        preventBackgroundScroll={true}
                        onNext={() => {
                          setIsOnlineScheduleOpen(false);
                          setShowOnlineScheduleTooltip(false);
                          setTimeout(() => {
                            history.replace({
                              pathname: location.pathname,
                              state: { onlineschedulestarted2: true },
                            });
                          }, 50);
                        }}
                        onClose={() => {
                          setIsOnlineScheduleOpen(false);
                          setShowOnlineScheduleTooltip(false);
                        }}
                      />
                    }
                    open={showOnlineScheduleTooltip}
                    position="right center"
                    trigger={
                      <SubNavItem to="/settings/onlineschedule" exact>
                        Online Schedule Settings
                      </SubNavItem>
                    }
                  />
                ) : (
                  <SubNavItem to="/settings/onlineschedule" exact>
                    Online Schedule Settings
                  </SubNavItem>
                )}
              </ListItem>
            </UL>
          )}
        </Div>
        <Div
          ref={adminHighlightRef}
          className="admin-position-highlight"
          style={
            decryptedPermission.manageAdministrationSettings
              ? getHighlightStyles(templateshowup1)
              : {}
          }
        >
          <Div
            cursor="pointer"
            display="flex"
            fontWeight="600"
            fontSize="14px"
            color={
              openMenu === "administration"
                ? "#2E2E2E"
                : "rgba(46, 46, 46, 0.50)"
            }
            fontFamily={globalFont}
            svgFontSize="16px"
            svgMarginLeft="8px"
            svgMarginTop="4px"
            marginTop="24px"
            onClick={() => toggleItem("administration")}
          >
            <Div id="setting_nav_scheduling">Administration</Div>
            {openMenu === "administration" ? (
              <FiChevronUp />
            ) : (
              <FiChevronDown />
            )}
          </Div>
        </Div>
        {openMenu === "administration" && (
          <UL
            textAlign="left"
            width="100%"
            listStyleType="none"
            padding="0"
            margin="0"
          >
            {/* Templates GuidePopup */}
            <Div
              ref={templatesHighlightRef}
              style={
                decryptedPermission.manageAdministrationSettings
                  ? getItemHighlightTemplate(templateshowup1)
                  : {}
              }
            >
              <Popup
                key={popupRefreshKey}
                offset={[-30, 18]}
                content={
                  <GetStartedPopup
                    title="Prepare Your Clinical Templates one"
                    description={
                      <div>
                        Go to Administration {">"} Templates menu to create and
                        assign note templates based on your Specialty and
                        category
                        <br />
                        <div style={{ marginTop: "5px" }}>
                          By doing so you can:
                        </div>
                      </div>
                    }
                    bullets={[
                      "Store and manage reusable documentation templates.",
                      "Create custom templates to match your documentation needs.",
                      "Quickly send specific templates to patient to be filled by them.",
                    ]}
                    currentStep={1}
                    totalSteps={8}
                    onNext={() => forexploretemplatemenu2()}
                    width="400px"
                    onClose={() => settemplateshowup1(false)}
                  />
                }
                open={
                  decryptedPermission.manageAdministrationSettings &&
                  templateshowup1
                }
                className="templatepopup m-t-10"
                trigger={
                  <ListItem
                    marginTop="16px"
                    onClick={handleInputChange("iconopen")}
                    style={
                      decryptedPermission.manageAdministrationSettings
                        ? getItemHighlightTemplate(templateshowup1)
                        : {}
                    }
                  >
                    {/* <SubNavItem
                      to="/settings/Templates"
                      exact
                      id="setting_nav_erx"
                    >
                      Templates
                    </SubNavItem> */}
                  </ListItem>
                }
                position="right center"
                context={templatesHighlightRef.current}
              />
            </Div>
            { (window.location.hostname.toLowerCase().includes("production") || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") && (
              <ListItem marginTop="16px" onClick={handleInputChange("iconopen")}>
                <SubNavItem to="/settings/Inventory" exact id="setting_nav_erx">
                  Inventory
                </SubNavItem>
              </ListItem>
            )}
            <ListItem
              ref={Setuperxref}
              style={
                decryptedPermission.manageAdministrationSettings
                  ? {
                    ...getHighlightStyles(isfromAccountSetuperx),
                  }
                  : {}
              }
              marginTop="16px"
              onClick={handleInputChange("iconopen")}
            >
              <Popup
                key={popupRefreshKey}
                offset={[40, 95]}
                content={
                  <GetStartedPopup
                    title="Create your eRx Account"
                    description={
                      <div>
                        Go to Settings {">"} Administration {">"} eRx Settings
                        menu to create your Digital Rx account to use
                        e-prescription.
                      </div>
                    }
                    currentStep={1}
                    totalSteps={4}
                    onNext={() => {
                      setisfromAccountSetuperx(false);
                      getStartedNextaccountsetup();
                      location.data = null;
                    }} // or handle steps
                    onClose={() => setisfromAccountSetuperx(false)}
                    width="320px"
                  />
                }
                open={
                  decryptedPermission.manageAdministrationSettings &&
                  isfromAccountSetuperx
                }
                disabled={!isfromAccountSetuperx}
                className="m-t-10"
                trigger={
                  <SubNavItem
                    to="/settings/ERXsettings"
                    exact
                    id="setting_nav_erx"
                    ref={(el) => (refMap.current["ERXsettings"] = el)}
                  >
                    eRx Settings
                  </SubNavItem>
                }
                position="left center"
              />
            </ListItem>

            <ListItem marginTop="16px" onClick={handleInputChange("iconopen")}>
              <SubNavItem
                to="/settings/Dataimport"
                exact
                id="setting_nav_erx"
                ref={(el) => (refMap.current["Dataimport"] = el)}
              >
                Data Import
              </SubNavItem>
            </ListItem>
          </UL>
        )}
      </Div>
      {decryptedPermission.manageAccountSettings && isPopupOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
          }}
          onClick={() => setIsPopupOpen(false)}
        />
      )}
      {decryptedPermission.configureBillingServices && labPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
          }}
          onClick={() => setLabPopup(false)}
        />
      )}
      {isOnlineScheduleOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1000,
          }}
          onClick={() => {
            setIsOnlineScheduleOpen(false);
            setShowOnlineScheduleTooltip(false);
          }}
        />
      )}
    </>
  );
};

export default SettingsNav;
